import axios from "axios-jsonp-pro";

const httpJsonp = axios.create({
    baseURL: "", // api的base_url
    timeout: 10000, // 请求超时时间
    // withCredentials: true,
});

// Add a request interceptor
httpJsonp.interceptors.request.use(
    function (config) {
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// Add a response interceptor
httpJsonp.interceptors.response.use(
    function (response) {
        return response.data || response;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default httpJsonp;



// WEBPACK FOOTER //
// ./src/util/httpJsonp.js